module.exports = __webpack_public_path__ + "img/back1.963bbdfe.png";